import "core-js/modules/es.symbol";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { widthClass, GRID_WIDTHS, offsetClass, GRID_OFFSETS } from '../util';
var propTypes = {
  /**
   width specifier, one of
   ['1/1', '1/2', '1/3', '2/3', '1/4','3/4','1/6','5/6','1/12','5/12','7/12',
  '1','2','3','4','5','6','7','8','9','10','12']
  */
  width: PropTypes.oneOf(GRID_WIDTHS),

  /**
    amount to offset the start of the column
    one of ['1/12', '1/6', '1/4', '1/3', '1/2', '5/12', '7/12',2/3', '3/4', 5/6', '11/12']
  */
  offset: PropTypes.oneOf(GRID_OFFSETS),

  /**
   child elements
  */
  children: PropTypes.node,

  /**
   additional style class(es) for the column
  */
  className: PropTypes.string,

  /**
    specifies if the column should be the last one in a grid row
    if set to yes, the next column in the grid will be displayed on a new row
  */
  breakRow: PropTypes.bool
};
var defaultProps = {
  width: '1/1',
  offset: undefined,
  children: undefined,
  className: undefined,
  breakRow: false
};

var Column = function Column(_ref) {
  var width = _ref.width,
      offset = _ref.offset,
      children = _ref.children,
      className = _ref.className,
      breakRow = _ref.breakRow,
      otherProps = _objectWithoutProperties(_ref, ["width", "offset", "children", "className", "breakRow"]);

  var offsetStyle = offset && offsetClass(offset);
  var stylingClass = classNames(widthClass(width), {
    'wds-l-end-row': breakRow
  }, className, offsetStyle);
  return React.createElement("div", _extends({
    className: stylingClass
  }, otherProps), children);
};

Column.propTypes = propTypes;
Column.defaultProps = defaultProps;
Column.displayName = 'Column';
export default Column;